namespace $ {

	$mol_style_define( $bog_ui_app, {

		Content_page: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			minWidth: 0,
		},

		Page_body: {
			padding: $mol_gap.block,
			color: $mol_theme.shade,
			overflow: {
				y: 'auto',
			},
			flex: {
				shrink: 1,
			},
		},

	} )

}
